{
  "nameInput": {
    "placeholder": "Siapa nama anda?"
  },
  "signIn": {
    "tagline": "Mulakan dengan niat.",
    "signingIn": "Sedang log masuk…",
    "continueApple": "Teruskan dengan Apple",
    "continueApple_aria": "Teruskan dengan Apple",
    "continueGoogle": "Teruskan dengan Google",
    "continueGoogle_aria": "Teruskan dengan Google",
    "logo_alt": "Rhemn",
    "footer": "Dengan log masuk, anda bersetuju dengan terma perkhidmatan kami dan <privacyLink>Dasar Privasi</privacyLink>.",
    "divider": "atau"
  },
  "email": {
    "identity": {
      "label": "Alamat e-mel",
      "placeholder": "you@example.com",
      "change": "Tukar",
      "change_aria": "Tukar alamat e-mel"
    },
    "password": {
      "label": "Kata laluan",
      "labelNew": "Pilih kata laluan",
      "placeholder": "Kata laluan",
      "placeholderNew": "Cipta kata laluan",
      "show": "Tunjukkan kata laluan",
      "hide": "Sembunyikan kata laluan"
    },
    "actions": {
      "continue": "Teruskan",
      "signIn": "Log masuk",
      "createAccount": "Cipta akaun",
      "forgot": "Lupa kata laluan?",
      "backToSignIn": "Kembali ke log masuk",
      "iVerified": "Saya telah mengesahkan e-mel saya",
      "resend": "Hantar semula pautan",
      "resendIn": "Hantar semula dalam {{time}}",
      "signInInstead": "Log masuk"
    },
    "busy": {
      "checking": "Menyemak…",
      "signingIn": "Sedang log masuk…",
      "creating": "Mencipta akaun anda…",
      "sending": "Menghantar…"
    },
    "switch": {
      "toCreate": "Baharu di Rhemn? <switchBtn>Cipta akaun</switchBtn>",
      "toSignIn": "Sudah ada akaun? <switchBtn>Log masuk</switchBtn>"
    },
    "strength": {
      "tooShort": "Sekurang-kurangnya 12 aksara.",
      "level1": "Bagus. Lagi panjang lagi kukuh.",
      "level2": "Kata laluan kukuh.",
      "level3": "Kata laluan sangat kukuh."
    },
    "sent": {
      "title": "Semak peti masuk anda",
      "body": "Kami menghantar pautan tetapan semula ke {{email}}. Ia luput dalam satu jam.",
      "resent": "Dihantar semula. Semak peti masuk anda."
    },
    "verify": {
      "title": "Sahkan e-mel anda",
      "body": "Kami menghantar pautan ke {{email}}. Buka pautan itu untuk melengkapkan persediaan akaun anda — kami akan menyambung secara automatik.",
      "waiting": "Menunggu anda membuka pautan…",
      "resent": "Dihantar semula. Semak peti masuk anda."
    },
    "errors": {
      "invalidEmail": "Itu tidak kelihatan seperti alamat e-mel.",
      "missingPassword": "Masukkan kata laluan anda.",
      "invalidCredential": "E-mel atau kata laluan tidak betul.",
      "emailInUse": "E-mel itu sudah mempunyai akaun. <signInBtn>Log masuk sahaja.</signInBtn>",
      "weakPassword": "Gunakan sekurang-kurangnya 12 aksara.",
      "passwordTooShort": "Gunakan sekurang-kurangnya 12 aksara.",
      "passwordCommon": "Kata laluan itu terlalu mudah diteka. Cuba sesuatu yang kurang dijangka.",
      "emailNotVerified": "Sahkan e-mel anda sebelum meneruskan.",
      "providerGoogle": "E-mel ini sudah disediakan dengan Google. Teruskan dengan Google di bawah.",
      "providerApple": "E-mel ini sudah disediakan dengan Apple. Teruskan dengan Apple di bawah.",
      "userDisabled": "Akaun ini telah dilumpuhkan.",
      "requiresRecentLogin": "Log masuk semula untuk membuat perubahan ini.",
      "sessionExpired": "Sesi anda telah tamat. Log masuk semula.",
      "expiredActionCode": "Pautan itu telah luput. Minta yang baharu.",
      "invalidActionCode": "Pautan itu tidak lagi sah. Minta yang baharu.",
      "tooManyRequests": "Terlalu banyak percubaan. Tunggu beberapa minit, atau tetapkan semula kata laluan anda.",
      "network": "Tiada sambungan. Semak rangkaian anda dan cuba lagi.",
      "operationNotAllowed": "Log masuk e-mel tidak tersedia buat masa ini.",
      "generic": "Sesuatu tidak kena. Sila cuba lagi."
    },
    "a11y": {
      "stepEmail": "Langkah 1 daripada 2. Masukkan alamat e-mel anda.",
      "stepPasswordSignIn": "Langkah 2 daripada 2. Masukkan kata laluan anda untuk log masuk.",
      "stepPasswordCreate": "Langkah 2 daripada 2. Pilih kata laluan untuk akaun baharu anda.",
      "stepSent": "Pautan tetapan semula dihantar. Semak peti masuk anda.",
      "stepVerify": "Akaun dicipta. Pautan pengesahan dihantar.",
      "resendReady": "Anda boleh menghantar semula pautan sekarang."
    }
  }
}
